import { useQuery } from '@tanstack/react-query';
import { getWalls } from '@/services/wallService';
import { queryKeys } from '@/lib/queryKeys';
import { logger } from '@/lib/logger';

export function useWalls(floorPlanId: string) {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: [...queryKeys.floorPlan(floorPlanId), 'walls'],
    queryFn: async () => {
      try {
        const walls = await getWalls(floorPlanId);
        logger.log(`Fetched ${walls.length} walls for floor plan ${floorPlanId}`);
        return walls;
      } catch (err: any) {
        // PostgREST 400 errors can occur if schema cache is stale
        // Return empty array instead of throwing to prevent console spam
        // Fixed: Removed .order() clause from wallService.ts that caused 400 errors
        if (err?.code === 'PGRST204' || err?.message?.includes('400')) {
          logger.warn(
            'Walls endpoint returned 400 (likely schema cache issue), returning empty array',
          );
          return [];
        }
        logger.error('Error fetching walls:', err);
        throw err;
      }
    },
    enabled: !!floorPlanId,
    retry: false, // Don't retry on PostgREST 400 errors
  });

  return {
    walls: data || [],
    isLoading,
    error,
    refetch,
  };
}
